import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const INVESTMENT_TYPE_OPTIONS = [
  { value: 'stocks', label: 'Stocks/ETFs' },
  { value: 'bonds', label: 'Bonds/Fixed Income' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'crypto', label: 'Cryptocurrency' },
  { value: 'private_equity', label: 'Private Equity/Venture Capital' },
  { value: 'commodities', label: 'Commodities/Precious Metals' },
  { value: 'other', label: 'Other' },
];

const InvestmentProfileFields = ({ formData, onInputChange, onCheckboxChange, isSubmitting }) => (
  <div className="border-t pt-4 mt-6">
    <h3 className="text-lg font-semibold mb-4 text-gray-900">Investment Profile</h3>
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="investment_experience">Investment Experience *</Label>
        <Select value={formData.investment_experience} onValueChange={(value) => onInputChange('investment_experience', value)} disabled={isSubmitting}>
          <SelectTrigger><SelectValue placeholder="Select experience level" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="<1">Less than 1 year</SelectItem>
            <SelectItem value="1-3">1-3 years</SelectItem>
            <SelectItem value="3-5">3-5 years</SelectItem>
            <SelectItem value="5-10">5-10 years</SelectItem>
            <SelectItem value="10+">10+ years</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="investment_count">Number of Investments *</Label>
        <Select value={formData.investment_count} onValueChange={(value) => onInputChange('investment_count', value)} disabled={isSubmitting}>
          <SelectTrigger><SelectValue placeholder="Select investment count" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="less_than_10">Less than 10 investments</SelectItem>
            <SelectItem value="11_25">11-25 investments</SelectItem>
            <SelectItem value="more_than_25">More than 25 investments</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="portfolio_value">Total Portfolio Value</Label>
        <Select value={formData.portfolio_value} onValueChange={(value) => onInputChange('portfolio_value', value)} disabled={isSubmitting}>
          <SelectTrigger><SelectValue placeholder="Select portfolio value" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="<50K">Under $50K</SelectItem>
            <SelectItem value="50K-250K">$50K - $250K</SelectItem>
            <SelectItem value="250K-1M">$250K - $1M</SelectItem>
            <SelectItem value="1M-5M">$1M - $5M</SelectItem>
            <SelectItem value="5M+">Over $5M</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label>Investment Types</Label>
        <div className="space-y-2">
          {INVESTMENT_TYPE_OPTIONS.map(type => (
            <div key={type.value} className="flex items-center space-x-2">
              <input
                type="checkbox"
                id={type.value}
                checked={formData.investment_types.includes(type.value)}
                onChange={() => onCheckboxChange(type.value)}
                disabled={isSubmitting}
                className="rounded border-gray-300"
              />
              <Label htmlFor={type.value} className="font-normal cursor-pointer">{type.label}</Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default InvestmentProfileFields;
